import React from 'react';
import {
    Edit, SimpleForm,
    TextInput, BooleanInput, ReferenceInput, AutocompleteInput, DateField,
} from 'react-admin';
import Toolbar from '../../components/toolbars/EditToolbar';
import Title from './Title';

import { required } from '../../util/fieldValidation';

import { withStyles } from '@material-ui/core/styles';
import styles from '../../styles/showStyles';

const StatesEdit = withStyles(styles)(({ classes,...props }) => (
    <Edit title={<Title />} {...props}>
        <SimpleForm toolbar={<Toolbar />} submitOnEnter={false} >
            <TextInput
                source='StateName'
                validate={[required()]}
            />
            <TextInput
                source='StateCode'
                validate={[required()]}
            />
            <ReferenceInput
                source='CountryID'
                reference='countries'
                validate={[required()]}
                sort={{ field: 'CountryName', order: 'ASC' }}
                perPage={1000}
                filter={{ Active: true }}
                filterToQuery={searchText => ({ CountryName_like: searchText })}
            >
                <AutocompleteInput optionText='CountryName' />
            </ReferenceInput>
            <BooleanInput
                source='Active'
            />
            <DateField
                source='CreateDate'
                showTime
                formClassName={classes.inlineBlock}
            />
            <DateField
                source='ModifiedDate'
                showTime
                formClassName={classes.inlineBlock}
            />
        </SimpleForm>
    </Edit>
));
export default StatesEdit;